import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import * as zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles((theme) => ({
  mapBanner: {
    maxWidth: "calc(100vw - 128px)",
    display: "flex",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    zIndex: zIndexes.positionalContainerZIndex,
    maxHeight: theme.spacing(6.875),
    boxSizing: "border-box",
    "&.low": {
      top: theme.spacing(3.625),
    },
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
  },
  notifications: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  notificationCtn: {
    display: "flex",
    flexDirection: "row",
    border: "1px solid",
    borderColor: theme.palette.border.default,
    borderTop: "none",
    borderBottom: "none",
    padding: "0px 10px",
  },
}));
